var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServ1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 159,
    viewBox: "0 0 113 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 39C240 105.274 186.274 159 120 159C53.7256 159 -0.000244141 105.274 -0.000244141 39C-0.000244141 -27.2742 53.7256 -81 120 -81C186.274 -81 240 -27.2742 240 39ZM38.4236 39C38.4236 84.0533 74.9465 120.576 120 120.576C165.053 120.576 201.576 84.0533 201.576 39C201.576 -6.05328 165.053 -42.5762 120 -42.5762C74.9465 -42.5762 38.4236 -6.05328 38.4236 39Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServ1);
export default __webpack_public_path__ + "static/media/serv-1.bb8ad95d74377fbd9b41d69dddeb3a6a.svg";
export { ForwardRef as ReactComponent };